// src/components/CheckableField/context.ts
import { createContext } from "react";
var CheckableFieldContext = createContext({
  id: "",
  name: "",
  label: ""
});
export { CheckableFieldContext };